import React from "react";
import {
	Divider,
	Dialog,
	DialogContent,
	DialogTitle,
	Typography,
} from "@material-ui/core";

import image from "./Images/vertical-process-icon.gif";

export default function AlertModal({ openModal, title, message }) {
	const [open, setOpen] = React.useState(false);

	React.useEffect(() => {
		setOpen(openModal);
		return () => {
			setOpen(false);
		};
	}, [openModal]);

	return (
		<Dialog open={open}>
			<DialogTitle id="alert-dialog-title" style={{ minWidth: 400 }}>
				<Typography
					style={{
						color: "black",
						textAlign: "center",
						fontSize: "2.0rem !important",
					}}>
					{title}
				</Typography>
				<Divider />
			</DialogTitle>

			<DialogContent align="center">
				<Typography
					variant="body2"
					style={{
						textAlign: "center",
						color: "black",
						fontSize: "1.0rem !important",
					}}>
					{message}
				</Typography>
				<span>
					{" "}
					<img src={image} alt="loading-img" />
				</span>
			</DialogContent>
		</Dialog>
	);
}
